import { SET_LOCALE } from '../actions/types';

export default function locale(state = '', action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_LOCALE:
				return action.payload;
			default:
				return state;
		}
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/locale.js